import React from 'react';

export const LoadingComponent = () => {
  return (
    <div className="global-loading-overlay">
      <div className="spinner-border text-danger" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};
